import React from 'react'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { locationMap, mobileMap } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <CFLink
              href="https://maps.app.goo.gl/ftmpHCDzDCzwQpeeA"
              target="_blank"
            >
              <CFImage
                src={mobileMap}
                w="100%"
                alt="Two Horns Sushi & BBQ Map"
              />
            </CFLink>
          </MobileScreen>
          <DefaultScreen>
            <CFLink
              href="https://maps.app.goo.gl/ftmpHCDzDCzwQpeeA"
              target="_blank"
            >
              <CFImage
                src={locationMap}
                w="100%"
                alt="Two Horns Sushi & BBQ Map"
              />
            </CFLink>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
